export const GenEnum = {

    ApplicationType: {
        Main: 1,
        Sub: 2
    },
    UserType: {
        AdminUser: 1,
        SuperAdmin: 2,
        EndUser: 3,
        TenentUser: 4
    },

    UserCategory: {
        Admin: 9,
        Employee: 10,
        Parent: 11,
        Student: 12,
        Driver: 13,
    },
    UserStatus: {
        Active: 5,
        InActive: 6
    },

    ObjectCategory: {
        Screen: 1103,
        Report: 1104,
    },

    Months: [
        { Id: 1, stxt: 'January' },
        { Id: 2, stxt: 'February' },
        { Id: 3, stxt: 'March' },
        { Id: 4, stxt: 'April' },
        { Id: 5, stxt: 'May' },
        { Id: 6, stxt: 'June' },
        { Id: 7, stxt: 'July' },
        { Id: 8, stxt: 'August' },
        { Id: 9, stxt: 'September' },
        { Id: 10, stxt: 'October' },
        { Id: 11, stxt: 'November' },
        { Id: 12, stxt: 'December' }
    ],

    Image: {
        imageUrl: 'Images/Actual/',
    },
    CheckList: [
        { Id: true, stxt: 'Yes' },
        { Id: false, stxt: 'No' },

    ],
    MenuType: {
        Menu: 1,
        Screen: 2,
    },
    Menucategory: {
        Screens: 1103,
        Reports: 1104,
    },

    ReportType: {
        DevExpressReport: 14,
        CrystalReport: 15,
    },
    ErrorTypes: {
        Info: 1,
        Success: 2,
        Warning: 3,
        Error: 4,
    },

    PwdChange: [
        {
            moodId: 1, moodValue: 'Reset Password', moodIcon: "fa fa-adjust", MoodGroup: "",
        },

    ],


}





// WEBPACK FOOTER //
// ./src/app/shell/shared/general.enum.ts